import { render, staticRenderFns } from "./history.vue?vue&type=template&id=f59ca096&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=f59ca096&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59ca096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f59ca096')) {
      api.createRecord('f59ca096', component.options)
    } else {
      api.reload('f59ca096', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=f59ca096&scoped=true&", function () {
      api.rerender('f59ca096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rank/history.vue"
export default component.exports